import type { Locale } from "@/lib/i18n/config";
import { SellersPage } from "./SellersPage";

/**
 * `sellers/new`: the sellers list with the "Add seller" drawer open over it.
 * The route stays so existing links keep working; closing the drawer goes back
 * to the list (same page and page size).
 */
export function SellerCreatePage({
  locale,
  limit = 20,
  offset = 0,
}: {
  locale: Locale;
  limit?: number;
  offset?: number;
}) {
  return <SellersPage locale={locale} limit={limit} offset={offset} create="seller" />;
}
